module.exports = __webpack_public_path__ + "static/media/golf-estate.bd6a9930.png";